import React from 'react';
import { Button, type ButtonProps } from 'antd';

export type HelpHintButtonProps = Omit<ButtonProps, 'type' | 'size'>;

const baseStyle: React.CSSProperties = {
  color: '#595959',
  background: '#ffffff',
  borderColor: '#d9d9d9',
};

/**
 * 全站统一的「说明」类按钮：白底、灰色文字、浅灰边框。
 * 用于打开帮助/解释弹窗；新页面请优先使用本组件以保持样式一致。
 */
export function HelpHintButton({ style, ...props }: HelpHintButtonProps) {
  return (
    <Button
      type="default"
      size="small"
      style={{ ...baseStyle, ...style }}
      {...props}
    />
  );
}

export default HelpHintButton;
